import { createContext, useCallback, useContext, useMemo, useState } from 'react';

/**
 * Contexto do coletor (módulo Armazém): guarda o OPERADOR identificado pelo
 * ID do funcionário (crachá) neste dispositivo. A conta logada é o DISPOSITIVO
 * (auth existente); a pessoa física vive na entidade de sistema `employees` e
 * o vínculo com o WMS em `wms_operators` — o DTO identificado carrega os dois
 * (employee_name/employee_code + role). Estado em memória por sessão de
 * página: identificação é rápida e o modelo do PRD é "sessão de CODE por OS"
 * (M4+), não login persistente.
 */
const CollectorEmployeeContext = createContext(null);

export const CollectorEmployeeProvider = ({ children }) => {
    const [employee, setEmployee] = useState(null);

    const identify = useCallback((identifiedOperator) => {
        setEmployee(identifiedOperator || null);
    }, []);

    const clear = useCallback(() => {
        setEmployee(null);
    }, []);

    const value = useMemo(() => ({ employee, identify, clear }), [employee, identify, clear]);

    return <CollectorEmployeeContext.Provider value={value}>{children}</CollectorEmployeeContext.Provider>;
};

export const useCollectorEmployee = () => {
    const context = useContext(CollectorEmployeeContext);
    if (!context) {
        throw new Error('useCollectorEmployee must be used within CollectorEmployeeProvider');
    }
    return context;
};
